import { Button, ButtonGroup } from "@mui/material";
import { User } from "firebase/auth";
import { httpsCallable } from "firebase/functions";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { useAuthContext } from "../Auth";
import { AutoCompleteUser } from "../components/UI/AutoCompleteUser";
import { ProgressContainer } from "../components/UI/ProgressContainer";
import { TableUsers } from "../components/UI/TableUsers";
import { DialogPrompResult, DialogPrompt } from "../dialogs/DialogPrompt";
import { fireFunctions } from "../firebase-config";
import { DBUser, getDisplayName, UserRole } from "../ostertalertypes";
import PageSetUser from "./PageSetUser";

export const PageEditUser: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const authCtx = useAuthContext();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedDBUser, setSelectedDBUser] = useState<DBUser | null>(null);
  const [selectedFireUser, setSelectedFirebaseUser] = useState<User | null>(null);
  const [editUser, setEditUser] = useState<boolean>(false);
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);

  const handleDeleteUser = async(user: DBUser) => {
    setIsLoading(true);
    await authCtx.deleteUser(user);
    setSelectedDBUser(null);
    setSelectedFirebaseUser(null);
    enqueueSnackbar("Benutzer erfolgreich gelöscht", {
      variant: "success",
      persist: false,
      anchorOrigin: { vertical: "top", horizontal: "center" },
    });
    setIsLoading(false);
  }

  function getActionBtn(user: DBUser) {
    return (
      <ButtonGroup size="small" aria-label="small button group">
        <Button key="one" onClick={() => setEditUser(true)}>Bearbeiten</Button>
        <Button key="two" disabled={user.role === UserRole.ADMIN} onClick={() => { setDialogOpen(true) }}>Löschen</Button>
      </ButtonGroup>
    );
  }

  const onUserSelected = async (selection: DBUser | null) => {
    if (selection) {
      const data = {
        userid: selection.userid
      };

      const getUser = httpsCallable(fireFunctions, "getUser");
      const user = await getUser(data);
      setSelectedFirebaseUser((user.data as any).user as User);
      selection.role = (user.data as any).admin ? UserRole.ADMIN : UserRole.NORMAL_ACCOUNT;
      setSelectedDBUser(selection);

    }
  };

  /**
   * Returning from user editing mask
   * @param changed
   */
  const onBackClick = (changed: boolean) => {
    setEditUser(false);
    if (changed) {
      setSelectedDBUser(null)
      setSelectedFirebaseUser(null);
    }
  }

  const onPromptClose = async (result: number) => {
    if (result === DialogPrompResult.YES && selectedDBUser) {
      await handleDeleteUser(selectedDBUser);
    }
    setDialogOpen(false);
  }


  return (
    <>
      <ProgressContainer size="max-w-5xl" isLoading={isLoading}>
        <h1 className="text-2xl mt-0 mb-10 text-gray-500 text-center md:text-left">Benutzer verwalten</h1>
        {!editUser &&
          <div>
            <AutoCompleteUser users={authCtx.allUsers} className="mb-10" selectedUser={selectedDBUser} onUserSelected={onUserSelected}></AutoCompleteUser>
            <TableUsers getActionBtn={getActionBtn} users={selectedDBUser ? [{user: selectedFireUser, userDetails: selectedDBUser}] : []}/>
          </div>
        }
        {editUser && <PageSetUser user={{user: selectedFireUser!, userDetail: selectedDBUser!}} onBackClick={onBackClick}/>}
      </ProgressContainer>
      <DialogPrompt open={dialogOpen} onClose={onPromptClose} caption="Benutzer löschen?" text={`Sind Sie sicher, dass sie den Benutzer
      ${selectedDBUser && getDisplayName(selectedDBUser)} löschen möchten? Diese Aktion ist nicht reversibel. Die eventuell vorhandenen Buchungen des Benutzers
       können danach nur noch über den Kalender gefunden und geändert werden.`}/>
    </>
  );
};
